import { getAdminRoles, getTeamIdFromRole } from 'utils/userUtils.ts';
import { AdminCard } from 'utils/adminCards.ts';

export function getTeamsForAdmin(roles: string[], card?: AdminCard): string[] {
  const adminRoles = getAdminRoles(roles);

  const teamIds = adminRoles
    .filter((role) => {
      if (card) return role.includes(card?.requiredRole);
      return true;
    })
    .map(getTeamIdFromRole);

  return teamIds;
}

export function getUrlForAdminCard(roles: string[], card: AdminCard) {
  const teamIds = getTeamsForAdmin(roles, card);
  if (teamIds.length > 1) {
    return `/admin/select-team?fn=${card.fn}`;
  }

  return `/admin/${teamIds[0]}/${card.fn}`;
}
